module.exports = "/../../dist/frontend/images/hero-zoe-banner.webp?9f538afce593fc004fc18245e6888a22";